import React from 'react';
import LoadingItem from './LoadingItem';

function LoadingWrapper() {
	return (
		<div className='mobile_only'>
			<div style={{ margin: 0, width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
				<div>
					<img src={require('../assets/images/alkalma_education_logo.png')} alt='AlkalmaUp' style={{ width: 'min(200px, calc(100vw - 100px))', marginTop: 30 }} className='mx-auto' />
				</div>
				<LoadingItem />
			</div>
		</div>
	);
}

export default LoadingWrapper;
